"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _availabilityTiles = require("@kyruus/availability-tiles");
var _globals = require("../../lib/constants/globals");
var _availability = require("../../lib/availability");
function ProviderAvailability(_ref) {
  let {
    apptInfo,
    availability,
    slotsStatus,
    handleRetry,
    onClickShowAvailability,
    availabilityTilesMessages,
    providerId,
    bookOnlineUrl,
    availabilityLinkTarget,
    onTimeSlotsClick,
    onAvailabilityTilesLoaded
  } = _ref;
  if (slotsStatus === _globals.SLOTS_ERROR_STATUS) {
    return /*#__PURE__*/_react.default.createElement(_availabilityTiles.ErrorAvailabilityTiles
    // as a first pass for slots v9, the user can't try re-fetching slots if an error occured
    // these props will render just a message without a retry button when an error has occured
    , {
      noMoreRetriesMsg: availabilityTilesMessages.availabilityErrorMsg,
      hasMoreRetries: false
    });
  }
  if (slotsStatus === _globals.SLOTS_LOADING_STATUS) {
    return /*#__PURE__*/_react.default.createElement(_availabilityTiles.LoadingAvailabilityTiles, {
      maxAvailabilitiesToDisplay: _globals.MAX_AVAILABILITIES_TO_DISPLAY
    });
  }
  if (slotsStatus === _globals.SLOTS_SUCCESS_STATUS) {
    return /*#__PURE__*/_react.default.createElement(_availabilityTiles.VisibleAvailabilityTiles, (0, _extends2.default)({
      availabilities: (0, _availabilityTiles.formatAvailabilityForTiles)(availability, bookOnlineUrl),
      handleRetry: handleRetry,
      providerId: providerId,
      maxAvailabilitiesToDisplay: _globals.MAX_AVAILABILITIES_TO_DISPLAY,
      availabilityLinkTarget: availabilityLinkTarget,
      onTimeSlotsClick: onTimeSlotsClick,
      onAvailabilityTilesLoaded: onAvailabilityTilesLoaded,
      displayLinkToViewMoreAvailabilities: true,
      viewMoreBookOnlineUrl: (0, _availability.appendApptInfoToBookingUrl)(apptInfo, bookOnlineUrl)
    }, availabilityTilesMessages));
  }

  // the initial ('skeleton') state
  return /*#__PURE__*/_react.default.createElement(_availabilityTiles.HiddenAvailabilityTiles, (0, _extends2.default)({
    maxAvailabilitiesToDisplay: _globals.MAX_AVAILABILITIES_TO_DISPLAY,
    onClickShowAvailabilities: onClickShowAvailability
  }, availabilityTilesMessages));
}
var _default = exports.default = ProviderAvailability;
ProviderAvailability.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ProviderAvailability"
};